import axios from 'axios';

export const isRequestCanceled = (error: unknown): boolean => axios.isCancel(error);

export const getRequestErrorReason = (error: unknown): string | undefined => {
    if (isRequestCanceled(error)) {
        return undefined;
    }

    const err = error as { response?: { data?: { reason?: string } } };
    return err?.response?.data?.reason;
};
